<template>
  <div class="body-container ui container-fluid">
    <app-header />
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import './sass/app.scss';
import AppHeader from './components/Header';

export default {
  name: 'App',
  components: {
    appHeader: AppHeader
  }
};
</script>

<style lang="scss" scoped>
  .body-container {
    margin: 25px auto 0 auto;
    max-width: 1200px;
    min-width: 320px;
  }
</style>
